import React, { useState, useMemo } from "react";
import { Row, Col, Card, CardBody, Input } from "reactstrap";
import SideMenuBar from "./SideMenuBar";

function ViewPublishContent({ contextData = [], itemCountsData }) {
    const [search, setSearch] = useState("");
    const [selectedSource, setSelectedSource] = useState("All");
    const [selectedStatus, setSelectedStatus] = useState("All");
    const [expanded, setExpanded] = useState({});

    // Filtering
    const filteredData = useMemo(() => {
        let data = [...contextData];

        if (selectedStatus !== "All") {
            data = data.filter((item) => item.status === selectedStatus);
        }
        if (selectedSource !== "All") {
            data = data.filter((item) => item.type === selectedSource);
        }
        if (search.trim() !== "") {
            data = data.filter((item) =>
                item.content?.toLowerCase().includes(search.toLowerCase())
            );
        }
        return data;
    }, [contextData, selectedSource, selectedStatus, search]);

    const groupedData = useMemo(() => {
        return filteredData.reduce((acc, item) => {
            if (!item.type) return acc;
            if (!acc[item.type]) acc[item.type] = [];
            acc[item.type].push(item);
            return acc;
        }, {});
    }, [filteredData]);

    const toggleSection = (type) => {
        setExpanded((prev) => ({ ...prev, [type]: !prev[type] }));
    };

    const parseSections = (rawContent) => {
        if (!rawContent) return [];
        const normalized = rawContent.replace(/\r\n|\n|\r/g, "\n");
        const parts = normalized.split("==").map(p => p.trim()).filter(Boolean);

        const sections = [];
        for (let i = 0; i < parts.length; i += 2) {
            const title = parts[i].replace(/^=+/, '').trim();
            const content = (parts[i + 1] || "").replace(/^=+/, '').trim();
            sections.push({ title, content });
        }
        return sections;
    };


    const SectionContent = ({ sections, isHeading }) => (
        sections.map((section, i) => (
            <div key={i} className="mb-3 pl-2">
                {isHeading ? (
                    <h6 style={{ fontWeight: 600 }}>{section.title}</h6>
                ) : (
                    <p>{section.title}</p>
                )}
                {section.content.split(/\r?\n/).map((line, idx) => <div key={idx}>{line}</div>)}
            </div>
        ))
    );

    return (
        <Row>
            <Col md="12" style={{ paddingRight: "300px" }}>
                <Row className="mb-4">
                    <Col md="12">
                        <Input
                            type="text"
                            placeholder="Search through all published content..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </Col>
                </Row>

                {Object.keys(groupedData).map((type) => (
                    <Card key={type} className="mb-3">
                        <CardBody>
                            <Row
                                style={{ cursor: "pointer" }}
                                onClick={() => toggleSection(type)}
                            >
                                <Col md="10">
                                    <h5>{type}</h5>
                                </Col>
                                <Col md="2" className="text-right">
                                    <span style={{ fontSize: 20, color: "#6c757d", userSelect: "none" }}>
                                        {expanded[type] ? "▾" : "▸"}
                                    </span>
                                </Col>
                            </Row>

                            {expanded[type] &&
                                groupedData[type].map((item) => (
                                    <div key={item.id} className="mt-3 pl-3">
                                        <SectionContent
                                            sections={parseSections(item.content)}
                                            isHeading={!(type === "Documents" || type === "Forms")}
                                        />
                                    </div>
                                ))
                            }
                        </CardBody>
                    </Card>
                ))}

                {filteredData.length === 0 && (
                    <div className="text-center text-muted mt-5">No content found</div>
                )}
            </Col>
            <SideMenuBar
                selectedSource={selectedSource}
                // selectedStatus={selectedStatus}
                onSourceChange={setSelectedSource}
                // onStatusChange={setSelectedStatus}
                contextData={contextData}
                itemCountsData={itemCountsData}
            />
        </Row>
    );
}
export default ViewPublishContent;